<script setup>
import { cn } from '@/lib/utils';
import { DropdownMenuTrigger as RadixDropdownMenuTrigger } from 'radix-vue';
import { computed } from 'vue';

const props = defineProps({
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;
  return delegated;
});
</script>

<template>
  <RadixDropdownMenuTrigger
    v-bind="delegatedProps"
    :class="cn('outline-none', props.class)"
  >
    <slot />
  </RadixDropdownMenuTrigger>
</template> 